import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Configuration explicite pour la persistance de session dans localStorage
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Utiliser localStorage pour persister les sessions (par défaut pour les apps web)
    storage: window.localStorage,
    // Auto-refresh de la session avant expiration
    autoRefreshToken: true,
    // Persister la session même après fermeture du navigateur
    persistSession: true,
    // Détecter automatiquement les changements de session
    detectSessionInUrl: true,
  },
});

// Démarrer l'auto-refresh de la session
supabase.auth.startAutoRefresh();

export interface UserProfile {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
  username: string | null;
  avatar_url: string | null;
}
